import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import WorkspaceIcon from "@mui/icons-material/DesktopWindows";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Autocomplete,
  Button,
  InputLabel,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  useTheme,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import {
  SimpleTreeView,
  TreeItemLabel,
  useTreeItem,
  TreeItemContent,
  TreeItemIconContainer,
  TreeItemGroupTransition,
  TreeItemRoot,
  TreeItemCheckbox,
} from "@mui/x-tree-view";
import { TreeItemIcon } from "@mui/x-tree-view/TreeItemIcon";
import { TreeItemProvider } from "@mui/x-tree-view/TreeItemProvider";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";

import {
  buildTree,
  findObjectInChildren,
  listAllParents,
} from "../../../../../containers/DocumentsSmartDocz/Wizard/helpers";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import {
  useDoczClients,
  useDoczMetadados,
  useDoczPasta,
  useDoczProjects,
} from "../../../../../hooks/docz";
import { language } from "../../../../../language";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import GenericModal from "../../../../modal-closebtn";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

const FormControlStyled = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginTop: "2%",
}));

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const Title = styled(InputLabel)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  doczProjetoList,
  doczMetadadoList,
  handleChangeProjeto,
  handleChangeConfigFields,
  handleChangeMetadados,
  addMetadados,
  removeMetadados,
  taskFields,
  businessObject,
}) {
  const idProjeto = jsonConfig?.idProjeto || "";
  const idEtiqueta = jsonConfig?.idEtiqueta || "";

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const metadados = jsonConfig?.metadados || [];
  const formFieldsVariables =
    taskFields?.filter(
      (taskField) =>
        !documentVariables.some((docItem) => docItem === taskField.id),
    ) || [];

  return (
    <>
      <Grid item size={{ xs: 12 }} sx={{ height: '29px', marginBottom: '30px', marginTop: '20px'}}>
        <Typography variant="h6" sx={{ fontWeight: '700'}} >{language.storageLocationInDocz}</Typography>
      </Grid>

      <Grid item size={12} container spacing={3} wrap="wrap">
        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
          <TextField
            required
            fullWidth
            id="clientDocz"
            name="clientDocz"
            label={language.client}
            value={jsonConfig?.nomeCliente || ""}
            onChange={handleChangeConfigFields}
            variant="outlined"
            disabled
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 8 }}>
          <TextField
            select
            required
            variant="outlined"
            id="idProjeto"
            name="idProjeto"
            label={language.project}
            fullWidth
            value={String(idProjeto)}
            onChange={handleChangeProjeto}
            renderValue={(value) => {
              if (!value) {
                return "";
              }
              const selectedItem =
                doczProjetoList &&
                doczProjetoList.find((item) => String(item.id) === value);
              return (
                <Typography variant="body1" color="primary">
                  {selectedItem?.name}
                </Typography>
              );
            }}
          >
            {doczProjetoList &&
              doczProjetoList?.map((item) => {
                return (
                  <MenuItem key={item.id} value={String(item.id)}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>
      </Grid>

      <Grid item size={12}>
        <TextField
          required
          fullWidth
          id="idEtiqueta"
          name="idEtiqueta"
          label={language.etiquetaVariable}
          value={idEtiqueta}
          onChange={handleChangeConfigFields}
          variant="outlined"
        />
      </Grid>

      <Grid container sx={{  marginBottom: '30px', marginTop: '45px'}}>
        <Typography variant="h6" sx={{ fontWeight: '550'}}>{language.metadataForIntegration}</Typography>
      </Grid>

      <Grid container item size={12} spacing={3} wrap="wrap">
        {metadados && metadados.length > 0 ? (
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.sourceSmartdocs}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.destinationDocz}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
              <Typography
                align="center"
                variant="body1"
                style={{ fontWeight: "410" }}
              >
                {language.groupIfFound}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
              <Typography
                align="center"
                variant="body1"
                style={{ fontWeight: "410" }}
              >
                {language.isADate}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
              <Typography
                align="center"
                variant="body1"
                style={{ fontWeight: "410" }}
              >
                {language.addRemove}
              </Typography>
            </Grid>
            {metadados.map((m, index) => {
              if (m.hidden) return null;

              return (
                <Fragment key={`m${index}_${m.da}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl style={{ width: "100%" }}>
                      <Title required>{language.sourceSmartdocs}</Title>
                      <Select
                        variant="outlined"
                        id="valor"
                        name="valor"
                        value={metadados[index]?.valor || ""}
                        onChange={(event) =>
                          handleChangeMetadados(event, index)
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {formFieldsVariables &&
                          formFieldsVariables?.map((fv) => {
                            return (
                              <MenuItem key={fv.id} value={fv.id}>
                                {fv.id}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl style={{ width: "100%" }}>
                      <Title required>{language.destinationDocz}</Title>
                      <Select
                        variant="outlined"
                        id="nome"
                        name="nome"
                        inputProps={{
                          id: "",
                        }}
                        value={metadados[index]?.nome || ""}
                        onChange={(event) =>
                          handleChangeMetadados(event, index)
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {doczMetadadoList &&
                          doczMetadadoList?.map((doczM) => {
                            return (
                              <MenuItem
                                key={`${doczM.id}_${doczM.nome}`}
                                value={doczM.nome}
                              >
                                {doczM.nome}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    style={{ display: "flex" }}
                  >
                    <FormControl>
                      <Checkbox
                        name="usarNaBusca"
                        onChange={(event) =>
                          handleChangeMetadados(event, index)
                        }
                        value={metadados[index]?.usarNaBusca || false}
                        checked={metadados[index]?.usarNaBusca || false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    style={{ display: "flex" }}
                  >
                    <FormControl>
                      <Checkbox
                        name="isDate"
                        onChange={(event) =>
                          handleChangeMetadados(event, index)
                        }
                        value={metadados[index]?.isDate || false}
                        checked={metadados[index]?.isDate || false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    style={{ display: "flex" }}
                  >
                    <IconButton
                      size="small"
                      color="primary"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) => removeMetadados(event, index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={12}
            justifyContent="center"
            alignItems="center"
            style={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noMetadataSelected}
            </Typography>
          </Grid>
        )}
        <Grid item size={{ xs: 12, sm: 6, md: 10}} ></Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 2}} justifyContent="center" alignItems="center" sx={{ display: 'flex'}}>
          <IconButtonStyled size="small" color="primary"
              onClick={() => addMetadados()}
            >
              <AddIcon />
            </IconButtonStyled>
        </Grid>
      </Grid>
    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarDoczDocumento({
  saveIntegrarDoczEtiquetaConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
}) {
  const [jsonConfig, setJsonConfig] = useState({
    idProjeto: "",
    idEtiqueta: "",
    descricao: "",
    departamento: "",
    metadados: [],
    idCliente: "",
    nomeCliente: "",
  });

  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "xl",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [treeData, setTreeData] = useState([]);
  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  const { data: doczClienteList, refetch: fetchDoczClienteList } = useDoczClients({
    enabled: false,
  });

  const { data: doczProjetoList, refetchWithParams: fetchDoczProjetoList } =
    useDoczProjects({
      enabled: false,
      params: { idCliente: jsonConfig?.idCliente },
    });

  const { data: doczMetadadoList, refetchWithParams: fetchDoczMetadadoList } =
    useDoczMetadados({
      enabled: false,
      params: { idProjeto: jsonConfig?.idProjeto },
    });

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        idProjeto: inputValues?.idProjeto,
        idEtiqueta: inputValues?.idEtiqueta,
        descricao: inputValues?.descricao,
        departamento: inputValues?.departamento,
        metadados: inputValues?.metadados,
        idCliente: inputValues?.idCliente,
        nomeCliente: inputValues?.nomeCliente,
      });
    }
  }, [inputValues]);

  // EFFECT 1 - Lista docz cliente
  useEffect(() => {
    fetchDoczClienteList();

  }, [fetchDoczClienteList ]);


  // EFFECT 2 - Preenche o cliente
  useEffect(() => {
    if (!doczClienteList) return;

    if (doczClienteList.length > 0) {
      const idCliente = doczClienteList[0].idCliente;
      const nomeCliente = doczClienteList[0].nomeCliente;
      setJsonConfig((prev) => ({
        ...prev,
        idCliente,
        nomeCliente,
      }));
    }
  }, [doczClienteList]);

  useEffect(() => {
    if (!jsonConfig || !jsonConfig.idCliente || !doczClienteList) return;

    fetchDoczProjetoList({
      idCliente: jsonConfig.idCliente 
    });

  }, [jsonConfig?.idCliente, doczClienteList]);

  useEffect(() => {
    if (!jsonConfig?.idProjeto) return;

    const projetoValue =
      doczProjetoList &&
      doczProjetoList.find(
        (v) => String(v.id) === String(jsonConfig.idProjeto),
      );
    if (projetoValue) {

      fetchDoczMetadadoList({
        idProjeto: projetoValue.id
      });
    }
  }, [jsonConfig?.idProjeto]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const validateConfig = (obj) => {
    const erros = [];

    if (!obj.idProjeto) {
      erros.push(language.destinationProjectRequired);
    }

    if(!obj.idEtiqueta){
      erros.push(language.etiquetaVariableRequired);
    }

    if(!obj.metadados || obj.metadados.length <= 0){
      erros.push(language.selectAtLeastOneMetadataForIntegration);
    }

    if(obj.metadados?.length){
      if(obj.metadados.filter(m => (!m.nome || !m.valor) && !m.hidden).length > 0){
        erros.push(language.fillOrRemoveEmptyMetadataRelationships);
      }
    }

    return erros;
  };

  const handleSave = () => {
    const doczFolderTree =
      jsonConfig?.doczFolderPath?.trim().length > 0
        ? jsonConfig?.doczFolderPath?.trim().split("/")
        : [];

    const idProjeto = jsonConfig?.idProjeto;
    const idEtiqueta = jsonConfig?.idEtiqueta;
    const descricao = jsonConfig?.descricao || null;
    const departamento = jsonConfig?.departamento || null;
    const metadados = jsonConfig?.metadados || [];
    const idCliente = jsonConfig?.idCliente;

    const inputObject = {
      idProjeto,
      idEtiqueta,
      descricao,
      departamento,
      metadados,
      idCliente,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //adicionando metadados default
      if (!inputObject.metadados.find((m) => m.nome === "Status")) {
        inputObject.metadados.push({
          nome: "Status",
          valorDefault: "ARQUIVADO",
          usarNaBusca: false,
          hidden: true,
        });
      }

      //salvando no modeler
      saveIntegrarDoczEtiquetaConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeProjeto = (event) => {
    const { value } = event.target;

    // list pastas
    const projetoValue =
      doczProjetoList &&
      doczProjetoList?.find((p) => String(p.id) === String(value));

    setJsonConfig((prev) => ({
      ...prev,
      idProjeto: String(value),
    }));

    if (projetoValue) {
      // do nothing ?
    }
  };

  const handleChangeConfigFields = (event) => {
    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeMetadados = (event, index) => {
    const { name, value, type, checked } = event.target;
    const metadados = jsonConfig?.metadados || [];

    metadados[index] = {
      ...metadados[index],
      [name]: type === "checkbox" ? checked : value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      metadados,
    }));
  };

  const addMetadados = () => {
    const metadados = jsonConfig?.metadados || [];

    metadados.push({
      nome: "",
      valor: "",
      usarNaBusca: false,
      hidden: false,
    });

    setJsonConfig((prev) => ({
      ...prev,
      metadados,
    }));
  };

  const removeMetadados = (event, index) => {
    const metadados = jsonConfig?.metadados || [];

    metadados.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      metadados,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        bigHeight
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tabValue}
            indicatorColor="secondary"
            textColor="secondary"
            onChange={handleChangeTab}
          >
            <Tab label={language.properties} />
            <Tab label={language.configuration} disabled />
            <Tab label={language.permissions} disabled />
          </Tabs>
        </Box>

        <FormPadding>
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={3}>
              <TabProperties
                businessObject={businessObject}
                taskFields={FormComponents}
                jsonConfig={jsonConfig}
                doczProjetoList={doczProjetoList}
                doczMetadadoList={doczMetadadoList}
                handleChangeProjeto={handleChangeProjeto}
                handleChangeConfigFields={handleChangeConfigFields}
                handleChangeMetadados={handleChangeMetadados}
                addMetadados={addMetadados}
                removeMetadados={removeMetadados}
              />
            </Grid>
          </TabPanel>
        </FormPadding>

        {hasConfigError && (
          <GenericSnackbar
            errorWithChildren={true}
            message={
              <div>
                {hasConfigError.map((err, index) => {
                  return <div key={`errorMessage_${index}`}>{err}</div>;
                })}
              </div>
            }
            handleClose={() => setHasConfigError(false)}
            duration={4000}
          />
        )}
      </GenericModal>
    )
  );
}

export default ModelerIntegrarDoczDocumento;
